export interface IConfig {
  readonly env
  readonly APP_BASE_URL: string
  readonly APP_ENV
  readonly COMMIT: string
  readonly STATIC_ASSETS_URL: string
  readonly GOOGLE_API_KEY
  readonly FULLSTORY_ANALYTICS_ID
  readonly LOG_LEVEL?: string
  readonly RECAPTCHA_KEY
  readonly SHIPPING_ENDPOINT
  readonly BOOKING_ENDPOINT
  readonly FX_CORE_ENDPOINT
  readonly USER_PROFILE_CORE_ENDPOINT
  readonly PUBLIC_API_ENDPOINT: string
  readonly PARTNER_BOOKING_CORE_ENDPOINT
  readonly FEED_CORE_V2_ENDPOINT
  readonly NOTIFICATION_CENTER_ENDPOINT: string
  readonly USER_LANE_APP_ID
  readonly WEBSOCKET_ENDPOINT
  readonly FORTO_X_URL: string
  readonly DEM_DET_CORE_ENDPOINT: string
  readonly DATADOG_RUM_APP_ID: string
  readonly DATADOG_RUM_CLIENT_TOKEN: string
  readonly DATADOG_RUM_SITE: string
  readonly DATADOG_RUM_SERVICE: string
  readonly DATADOG_RUM_ENABLED: string
  readonly DATADOG_RUM_SESSION_REPLAY_ENABLED: string
  readonly DOCUMENTS_CORE_V2_ENDPOINT: string
  readonly TRANSPORT_UNITS_ENDPOINT: string
  readonly QUOTATION_CORE_ENDPOINT: string
  readonly BILLING_CORE_ENDPOINT: string
  readonly CUSTOM_STATUS_ENDPOINT: string
  readonly CARBON_EMISSIONS_ENDPOINT: string
  readonly SUBSCRIPTIONS_ENDPOINT: string
  readonly CUSTOMER_MASTER_DATA_ENDPOINT: string
  readonly SHIP_V2_URL: string
}

export const { config } = window

if (!config.USER_LANE_APP_ID) {
  throw new Error('UserLane is not configured')
}

if (!config.WEBSOCKET_ENDPOINT) {
  throw new Error('Required ENV variable WEBSOCKET_ENDPOINT is not configured')
}
